import clsx from 'clsx';
import { fromNow } from '@/lib/format';

interface Props {
  online: boolean | undefined;
  lastSeen: string | null | undefined;
  size?: number;
  withTooltip?: boolean;
  className?: string;
}

export default function PresenceDot({ online, lastSeen, size = 10, withTooltip = true, className }: Props) {
  const label = online
    ? 'Online'
    : lastSeen
      ? `Last seen ${fromNow(lastSeen)}`
      : 'Offline';
  return (
    <span
      aria-label={withTooltip ? label : undefined}
      title={withTooltip ? label : undefined}
      className={clsx(
        'inline-block rounded-full ring-2 ring-white dark:ring-ink-800',
        online ? 'bg-emerald-500' : 'bg-ink-300 dark:bg-ink-600',
        className,
      )}
      style={{ width: size, height: size }}
    />
  );
}
